import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { ApiBase } from '../api-base';
import { LanguageResolver } from '../../infrastructure/language-resolver';

@inject(IHttpClient, LanguageResolver)
export class LoginCodeApi extends ApiBase {
    private readonly _base = 'api/auth/login-code';

    constructor(http: IHttpClient, private readonly _languageResolver: LanguageResolver) {
        super(http);
    }

    public requestCode(email: string): Promise<any> {
        const url = `${this._base}/request-code?culture=${encodeURIComponent(this._languageResolver.currentLanguage)}`;
        return this.post(url, { email })
            .then(r => r.content);
    }

    public verifyCode(email: string, code: string): Promise<any> {
        return this.post(`${this._base}/verify-code`, { email, code })
            .then(r => r.content);
    }
}
